export default "__VITE_ASSET__0859c83e__"